export default __webpack_public_path__ + "static/media/36.df416f99.jpg";